import { createBrowserRouter, Navigate } from 'react-router-dom'

import { ROLES } from 'utils/config'
import routes from 'routes'
import ProtectedRoute from 'routes/ProtectetRoute'

import HomeView from 'views/HomeView'
import LoginView from 'views/Auth/LoginView'
import RegisterView from 'views/Auth/RegisterView'
import ResetPasswordView from 'views/Auth/ResetPasswordView'
import ConfirmEmaiView from 'views/Auth/ConfirmEmaiView'

import ProfileView from 'views/Profile/ProfileView'

import UserDashboardView from './User/UserDashboardView'
import UserProjectsView from './User/UserProjectsView'
import UserBillingsView from './User/UserBillingsView'
import UserProjectsDetailsView from './User/UserProjectsDetailsView'
import UserTaskDetailsView from './User/UserTaskDetailsView'
import UserTaskUploadView from './User/UserTaskUploadView'
import UserMyTasksView from './User/UserMyTasksView'
import LogicGetUserTasks from './logic/LogicGetUserTasks'
import UserBillingsV2View from './User/Billings/UserBillingsV2View'
import UserBillingsV2DetailsView from './User/Billings/UserBillingsV2DetailsView'

import AdminProjectsView from './Admin/AdminProjectsView'
import AdminProjectsCreateView from './Admin/AdminProjectsCreateView'
import AdminUsersView from './Admin/AdminUsersView'
import AdminUsersDetailsView from './Admin/AdminUsersDetailsView'
import AdminBillingsView from './Admin/AdminBillingsView'
import AdminBillingsUserDetails from './Admin/AdminBillingsUserDetails'
import AdminBillingsV2View from './Admin/Billings/AdminBillingsV2View'
import AdminBillingsV2CreateView from './Admin/Billings/AdminBillingsV2CreateView'
import AdminBillingsV2DetailsView from './Admin/Billings/AdminBillingsV2DetailsView'
import AdminSettingsView from './Admin/AdminSettingsView'
import AdminProjectsDetailsView from './Admin/AdminProjectsDetailsView'
import AdminProjectsDetailsUsersView from './Admin/AdminProjectsDetailsUsersView'
import AdminProjectsEditView from './Admin/AdminProjectsEditView'
import AdminTaskCreateView from './Admin/AdminTaskCreateView'
import AdminTaskImportView from './Admin/AdminTaskImportView'
import AdminTaskEditView from './Admin/AdminTaskEditView'
import AdminTaskDetailsView from './Admin/AdminTaskDetailsView'
import App from 'App'

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        element: <ProtectedRoute />,
        children: [
          { index: true, element: <HomeView /> },
          { path: routes.profile, element: <ProfileView /> },
        ],
      },
      { path: routes.login, element: <LoginView /> },
      { path: routes.register, element: <RegisterView /> },
      { path: routes.resetPassword, element: <ResetPasswordView /> },
      { path: routes.confirmEmail, element: <ConfirmEmaiView /> },
      {
        element: (
          <ProtectedRoute allowedRoles={[ROLES.user.value]}>
            <LogicGetUserTasks />
          </ProtectedRoute>
        ),
        children: [
          { id: routes.user, path: routes.user, element: <UserDashboardView /> },
          { id: routes.userProjects, path: routes.userProjects, element: <UserProjectsView /> },
          { id: routes.userProjectsDetails, path: routes.userProjectsDetails, element: <UserProjectsDetailsView /> },
          {
            id: routes.userProjectsDetailsTask,
            path: routes.userProjectsDetailsTask,
            element: <UserTaskDetailsView />,
          },
          {
            id: routes.userProjectsDetailsTaskUpload,
            path: routes.userProjectsDetailsTaskUpload,
            element: <UserTaskUploadView />,
          },
          { id: routes.userMyTasks, path: routes.userMyTasks, element: <UserMyTasksView /> },
          { id: routes.userBillings, path: routes.userBillings, element: <UserBillingsView /> },
          { id: routes.userBillingsV2, path: routes.userBillingsV2, element: <UserBillingsV2View /> },
          {
            id: routes.userBillingsV2Details,
            path: routes.userBillingsV2Details,
            element: <UserBillingsV2DetailsView />,
          },
        ],
      },
      {
        element: <ProtectedRoute allowedRoles={[ROLES.admin.value]} />,
        children: [
          { id: routes.adminProjects, path: routes.adminProjects, element: <AdminProjectsView /> },
          { id: routes.adminProjectsDetails, path: routes.adminProjectsDetails, element: <AdminProjectsDetailsView /> },
          {
            id: routes.adminProjectsDetailsUsers,
            path: routes.adminProjectsDetailsUsers,
            element: <AdminProjectsDetailsUsersView />,
          },
          { id: routes.adminProjectsCreate, path: routes.adminProjectsCreate, element: <AdminProjectsCreateView /> },
          { id: routes.adminProjectsEdit, path: routes.adminProjectsEdit, element: <AdminProjectsEditView /> },
          { id: routes.adminProjectsEditTask, path: routes.adminProjectsEditTask, element: <AdminTaskEditView /> },
          {
            id: routes.adminProjectsDetailsTask,
            path: routes.adminProjectsDetailsTask,
            element: <AdminTaskDetailsView />,
          },
          {
            id: routes.adminProjectsCreateTasks,
            path: routes.adminProjectsCreateTasks,
            element: <AdminTaskCreateView />,
          },
          {
            id: routes.adminProjectsImportTasks,
            path: routes.adminProjectsImportTasks,
            element: <AdminTaskImportView />,
          },
          { id: routes.adminBillings, path: routes.adminBillings, element: <AdminBillingsView /> },
          {
            id: routes.adminBillingsUserDetails,
            path: routes.adminBillingsUserDetails,
            element: <AdminBillingsUserDetails />,
          },
          { id: routes.adminBillingsV2, path: routes.adminBillingsV2, element: <AdminBillingsV2View /> },
          {
            id: routes.adminBillingsV2Create,
            path: routes.adminBillingsV2Create,
            element: <AdminBillingsV2CreateView />,
          },
          {
            id: routes.adminBillingsV2Details,
            path: routes.adminBillingsV2Details,
            element: <AdminBillingsV2DetailsView />,
          },
          { id: routes.adminUsers, path: routes.adminUsers, element: <AdminUsersView /> },
          { id: routes.adminUsersDetails, path: routes.adminUsersDetails, element: <AdminUsersDetailsView /> },
          { id: routes.adminSettings, path: routes.adminSettings, element: <AdminSettingsView /> },
        ],
      },
      {
        path: routes.noMatch,
        element: <Navigate to={routes.home} />,
      },
    ],
  },
])

export default router
